import Page from "../../finwell/pages/Page";
import Loader from "../../components/Loader/Loader";
import { useEffect, useState } from "react";
import SystemUsageReportHomeSection from "../../components/Reports/SystemUsageReports/SystemUsageReportHomeSection";

export const SystemUsageReports = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <Loader start={isLoading} />
            <Page>
                <SystemUsageReportHomeSection
                    setIsLoading={setIsLoading} 
                    isLoading={isLoading}
                    isMobile={false}
                />
            </Page>
        </>
    )
}

export default SystemUsageReports;